var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2622_10489)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_10489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 58.2202V31.9702H32.5V58.2202C32.5 59.2148 32.8951 60.1686 33.5983 60.8719C34.3016 61.5751 35.2554 61.9702 36.25 61.9702H62.5V59.4702H36.25C35.9185 59.4702 35.6005 59.3385 35.3661 59.1041C35.1317 58.8697 35 58.5517 35 58.2202Z",
    fill: "#20435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6253 36.9702H53.7503L57.2416 40.4615L51.8753 45.8277L49.3753 43.3277L40.3516 52.3515L42.1253 54.1252L49.3816 46.8752L51.8816 49.3752L59.0153 42.2415L62.5003 45.7202V38.8452C62.5003 38.3479 62.3028 37.871 61.9511 37.5194C61.5995 37.1678 61.1226 36.9702 60.6253 36.9702Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2622_10489",
    x: 0.5,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2622_10489"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_10489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32.5 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/efficiency.b94be4395d15c003390c69c4563ec3bc.svg";
export { ForwardRef as ReactComponent };